import { useAppData } from "../state/AppData";

export function BackendDownBanner() {
  const { healthError, featuresEverLoaded, featuresError, wsState } = useAppData();

  // Fires both for a cold start (backend never reachable) and a mid-session
  // drop (health poll was succeeding, now isn't) — BUILD THIS #9 covers both,
  // not just the first-load case. usePolling keeps last-known-good data on
  // screen regardless, so this is purely the "tell the user" layer.
  if (!healthError) return null;

  return (
    <div className="backend-banner" role="alert">
      <span>{featuresEverLoaded ? "Lost contact with the backend" : "Backend unreachable"} — retrying automatically…</span>
      <span style={{ opacity: 0.8, fontSize: 11 }}>
        ({featuresError || healthError || "no response"}, ws: {wsState})
      </span>
    </div>
  );
}
